var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLoader = function SvgLoader(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49,
    height: 48,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24.5,
    cy: 24,
    r: 16,
    stroke: "var(--loader-ring, #DDDEDF)",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--loader-arc, #5B6770)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4,
    d: "M24.5 8a16 16 0 0 1 16 16"
  })));
};
export default SvgLoader;